const fileSaver = require("./js/FileSaver.js");

export default (app) => {
  const file = {
    /**
    * @name 文件压缩
    * @description
    *  1、将文件转img对象
    *  2、获取文件宽高比例
    *  3、自定义等比例缩放宽高属性，
    *  4、canvas重新绘制图片
    *  5、canvas转二进制对象转文件对象，返回
    * @returns { File } 文件
    */
    imgCompress: async function (file, scale) {
      if (!scale) return file;
      // 将文件转img对象
      let optWidth = scale.w || 0;
      let optHeight = scale.h || 0;
      if (optWidth == 0 && optHeight == 0) return file;

      const img = await this.fileToImg(file);
      //如果
      if (optWidth == 0) optWidth = img.width * 2;
      if (optHeight == 0) optHeight = img.height * 2;
      if (optWidth > img.width && optHeight > img.height) return file;

      return new Promise((resolve, reject) => {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        // 获取文件宽高比例
        const { width: originWidth, height: originHeight } = img;
        let imageWidth = optWidth;
        let imageHeight = optHeight; // 等比例缩放高
        let aspectRatio = +(originWidth / originHeight).toFixed(2); //比例取小数点后两位)
        if (imageHeight * aspectRatio > imageWidth) {
          imageHeight = imageWidth / aspectRatio;
        } else {
          imageWidth = imageHeight * aspectRatio;
        }
        canvas.width = imageWidth;
        canvas.height = imageHeight;
        // canvas重新绘制图片
        context.drawImage(img, 0, 0, imageWidth, imageHeight);
        // canvas转二进制对象转文件对象，返回
        const type = 'image/jpeg';
        canvas.toBlob(function (blob) {
          const f = new File([blob], file.name, {
            type,
            lastModified: file.lastModified
          });
          resolve(f);
        }, type);
      });
    },

    // file转换成img对象
    /**
     * @param {file} file 
     * @returns Promise<img>
     */
    fileToImg: function (file) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        const reader = new FileReader();
        reader.onload = function (e) {
          img.src = e.target.result;
          // resolve(img)
        };
        reader.onerror = function (e) {
          reject(e);
        };
        reader.readAsDataURL(file);
        img.onload = function () {
          resolve(img);
        };
        img.onerror = function (e) {
          reject(e);
        };
      });
    },
    urlToBase64(imgUrl) {
      return new Promise(resolve => {
        var img = new Image();
        img.src = imgUrl;
        img.setAttribute('crossOrigin', 'anonymous');
        img.onload = (() => {
          var canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          var ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          var dataURL = canvas.toDataURL("image/png");
          //console.log('UgetBase64Image.dataURL ', dataURL);
          resolve(dataURL.replace(/^data:image\/(png|jpg);base64,/, ""));
        });
      });
    },
    fileSaver
  };
  return { file };
}; 